import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { useNavigate } from 'react-router-dom';
import useClickOutside from '../../../Hooks/useClickOutside';
import UseTimeCountdown from '../../../Hooks/UseTimeCountdown';
import { onSaleNftData } from '../../../Shared/ExploreDataFactory';

import './OnSale.scss';


export interface IAppProps {
}

export function OnSale(props: IAppProps) {
    const [exploreEtherDatas, setExploreEtherDatas] = React.useState([...onSaleNftData])


    // Filter Blockchain Drop down
    const [blockchainDropOpen, setBlockchainDropOpen] = React.useState(false)
    const [blockchainText, setBlockchainText] = React.useState('Blockchain');
    let blockchainDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(blockchainDropRef, () => setBlockchainDropOpen(false))

    // Filter Categories Drop down
    const [categoriesDropOpen, setCategoriesDropOpen] = React.useState(false)
    const [categoriesText, setCategoriesText] = React.useState('Categories');
    let CategoriesDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(CategoriesDropRef, () => setCategoriesDropOpen(false))

    // Filter Collections Drop down
    const [collectionsDropOpen, setCollectionsDropOpen] = React.useState(false)
    const [collectionsText, setCollectionsText] = React.useState('Collections');
    let collectionsDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(collectionsDropRef, () => setCollectionsDropOpen(false))

    // Filter Sale Type Drop down
    const [saleTypeDropOpen, setSaleTypeDropOpen] = React.useState(false)
    const [saleTypeText, setSaleTypeText] = React.useState('Sale Type');
    let saleTypeDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(saleTypeDropRef, () => setSaleTypeDropOpen(false))

    // Filter Price Range Drop down
    const [priceRangeDropOpen, setPriceRangeDropOpen] = React.useState(false)
    const [priceRangeText, setPriceRangeText] = React.useState('Price Range');
    let priceRangeDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(priceRangeDropRef, () => setPriceRangeDropOpen(false))

    // Filter Sort by Drop down
    const [sortByDropOpen, setSortByDropOpen] = React.useState(false)
    const [sortByText, setSortByText] = React.useState('Sort by');
    let sortByDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(sortByDropRef, () => setSortByDropOpen(false))




    let navigate = useNavigate();
    const handleNFTOnClick = (id: number) => {
        navigate(`/exploreNftDetails/${id}/bids`)
    }
    const handleLoveOnClick = (index: number) => {
        const previousData = [...exploreEtherDatas]
        const findMatchData = previousData[index]

        if (findMatchData.nftPostData.isMyloves) {
            findMatchData!.nftPostData.loves = findMatchData.nftPostData.loves - 1
            findMatchData.nftPostData.isMyloves = false;
            setExploreEtherDatas(previousData)
        } else {
            findMatchData!.nftPostData.loves = findMatchData.nftPostData.loves + 1
            findMatchData.nftPostData.isMyloves = true;
            setExploreEtherDatas(previousData)
        }
    }
    //handle nft three dot modal
    const [threeDotText, setThreeDotText] = React.useState('')
    const threeDotModalRefs = React.useRef(new Array())
    const [clickedThreeDotIndex, setClickedThreeDotIndex] = React.useState(-1)
    const [isThreeDotModalOpen, setIsThreeDotModalOpen] = React.useState(() => [].map((x) => false));

    useClickOutside({ current: threeDotModalRefs.current[clickedThreeDotIndex] }, () => {
        const newVisibilities = [...isThreeDotModalOpen];
        newVisibilities[clickedThreeDotIndex] = false;
        setIsThreeDotModalOpen(newVisibilities);
    })
    const hanldeThreeDotBtn = (index: any) => {
        const newVisibilities = [...isThreeDotModalOpen];
        newVisibilities[index] = !newVisibilities[index];

        setIsThreeDotModalOpen(newVisibilities);
        setClickedThreeDotIndex(index)
    };

    React.useEffect(() => {
        const arrayData = threeDotModalRefs.current.map((data, index) => `${index}`)
        setIsThreeDotModalOpen(() => arrayData.map((x) => false));
    }, [])




    const onSaleFilterOptionStye = "border  bg-white dark:bg-transparent dark:border-[#6561B1] relative cursor-pointer flex justify-center items-start xs:p-3 xl:p-2 2xl:p-3 rounded-md"
    return (
        <div className="on_sale_main_box">

            {/* Filter Sections in top */}
            <div className="relative pr-10 pl-4 xl:pr-0 xl:pl-0">
                {/* <div className="xl:hidden left_arrow_bg h-full xs:w-8 sm:w-12 absolute left-0 flex justify-end items-center"></div> */}
                <div className="xl:hidden right_arrow_bg h-full xs:w-12 sm:w-14 absolute right-0 flex justify-end items-center"></div>

                {/* <button className="text-base bg-l-White absolute -right-0 border-2 dark:border-gray-600 top-2 md:hidden dark:bg-cusBlack p-2 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15.978" height="15.012" viewBox="0 0 34.978 35.012">
                        <path id="filter" d="M1.093,5.935H17.735a5.091,5.091,0,0,0,9.944,0h6.206a1.093,1.093,0,0,0,0-2.186H27.679a5.09,5.09,0,0,0-9.943,0H1.093a1.093,1.093,0,0,0,0,2.186ZM19.8,4.845s0-.008,0-.012a2.9,2.9,0,0,1,5.808,0v.016a2.9,2.9,0,0,1-5.808,0ZM33.885,28.581H27.679a5.09,5.09,0,0,0-9.943,0H1.093a1.093,1.093,0,1,0,0,2.186H17.735a5.091,5.091,0,0,0,9.944,0h6.206a1.093,1.093,0,0,0,0-2.186Zm-11.178,4a2.907,2.907,0,0,1-2.9-2.9v0s0-.008,0-.012a2.9,2.9,0,0,1,5.808,0v.016a2.907,2.907,0,0,1-2.9,2.9ZM33.885,16.165H17.243a5.091,5.091,0,0,0-9.944,0H1.093a1.093,1.093,0,1,0,0,2.186H7.3a5.09,5.09,0,0,0,9.943,0H33.885a1.093,1.093,0,1,0,0-2.186Zm-18.711,1.09s0,.008,0,.012a2.9,2.9,0,0,1-5.808,0v-.016a2.9,2.9,0,0,1,5.808,0Z" transform="translate(0 0.248)" fill="#6f6dab" />
                    </svg>
                </button> */}


                <div className="flex justify-start xl:justify-between items-start my-6 space-x-4 overflow-x-auto xl:overflow-x-visible">

                    <div className="flex gap-y-3 justify-start items-start space-x-4">
                        <div className={onSaleFilterOptionStye}
                            onClick={() => setBlockchainDropOpen(!blockchainDropOpen)}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 md:w-5" viewBox="0 0 21.197 24.477">
                                <path id="block" d="M44.895,0,34.3,6.119V18.357l10.6,6.119,10.6-6.119V6.119ZM35.73,7.775l8.447,4.875v9.756L35.73,17.529Zm9.882,14.631V12.65l8.447-4.875v9.754Z" transform="translate(-34.296)" fill="#565099" />
                                <path id="block-2" data-name="block" d="M44.895,0,34.3,6.119V18.357l10.6,6.119,10.6-6.119V6.119Zm8.447,6.533-8.447,4.875L36.448,6.533l8.447-4.877ZM35.73,7.775l8.447,4.875v9.756L35.73,17.529Zm9.882,14.631V12.65l8.447-4.875v9.754Z" transform="translate(-34.296)" fill="#6561b1" />
                            </svg>

                            <div ref={blockchainDropRef} className="text-left ml-2">
                                <div className="flex justify-between items-center break-all">
                                    <h4 className="text-[#6F6DAB] font-semibold text-xs sm:text-sm xl:text-base mr-1 max-w-[140px]
                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{blockchainText}</h4>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className={`h-4 w-4 transition-all ${blockchainDropOpen && 'rotate-180'}`}
                                        fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>

                                <AnimatePresence>
                                    {blockchainDropOpen &&
                                        <motion.div
                                            animate={blockchainDropOpen ? "open" : "closed"}
                                            initial={{ y: -15, }}
                                            variants={{
                                                open: { y: 0, },
                                                closed: { y: -100, },
                                            }}
                                            exit={{ opacity: 0, y: -15 }}
                                            transition={{ duration: 0.2 }}
                                            className="rounded-xl overflow-hidden bg-white dark:bg-[#292757] shadow-lg top-12 left-0 lg:absolute
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] z-50
                                                        min-w-[140px] max-w-[160px]">
                                            {['Blockchain', 'Blockchain 1', 'Blockchain 3', 'Blockchain 4', 'Blockchain 5',].map(item =>
                                                <div onClick={() => { setBlockchainText(item) }}
                                                    className={`py-3 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                    <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium 
                                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                                </div>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>


                        <div className={onSaleFilterOptionStye}
                            onClick={() => setCategoriesDropOpen(!categoriesDropOpen)}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 md:w-5" viewBox="0 0 20.335 20.335">
                                <g id="category" transform="translate(-2 -2)">
                                    <g id="Group_1365" data-name="Group 1365" transform="translate(13.184 13.184)">
                                        <path id="Path_896" data-name="Path 896" d="M41.88,44.151H37.271A2.271,2.271,0,0,1,35,41.88v-6.2A.68.68,0,0,1,35.678,35h6.2a2.271,2.271,0,0,1,2.271,2.271V41.88a2.271,2.271,0,0,1-2.271,2.271Zm-5.524-7.8V41.88a.911.911,0,0,0,.915.915H41.88a.911.911,0,0,0,.915-.915V37.271a.911.911,0,0,0-.915-.915Z" transform="translate(-35 -35)" fill="#6561b1" />
                                    </g>
                                    <g id="Group_1366" data-name="Group 1366" transform="translate(2 13.184)">
                                        <path id="Path_897" data-name="Path 897" d="M8.88,44.151H4.271A2.271,2.271,0,0,1,2,41.88V37.271A2.271,2.271,0,0,1,4.271,35h6.2a.68.68,0,0,1,.678.678v6.2A2.271,2.271,0,0,1,8.88,44.151Z" transform="translate(-2 -35)" fill="#6561b1" />
                                    </g>
                                    <g id="Group_1367" data-name="Group 1367" transform="translate(13.184 2)">
                                        <path id="Path_898" data-name="Path 898" d="M41.88,11.151h-6.2A.68.68,0,0,1,35,10.473v-6.2A2.271,2.271,0,0,1,37.271,2H41.88a2.271,2.271,0,0,1,2.271,2.271V8.88A2.271,2.271,0,0,1,41.88,11.151Z" transform="translate(-35 -2)" fill="#6561b1" />
                                    </g>
                                    <g id="Group_1368" data-name="Group 1368" transform="translate(2 2)">
                                        <path id="Path_899" data-name="Path 899" d="M10.473,11.151h-6.2A2.271,2.271,0,0,1,2,8.88V4.271A2.271,2.271,0,0,1,4.271,2H8.88a2.271,2.271,0,0,1,2.271,2.271v6.2a.68.68,0,0,1-.678.678Z" transform="translate(-2 -2)" fill="#6561b1" />
                                    </g>
                                </g>
                            </svg>

                            <div ref={CategoriesDropRef} className="text-left ml-2">
                                <div className="flex justify-between items-center break-all">
                                    <h4 className="text-[#6F6DAB] font-semibold text-xs sm:text-sm xl:text-base mr-1 max-w-[140px]
                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{categoriesText}</h4>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className={`h-4 w-4 transition-all ${categoriesDropOpen && 'rotate-180'}`}
                                        fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>

                                <AnimatePresence>
                                    {categoriesDropOpen &&
                                        <motion.div
                                            animate={categoriesDropOpen ? "open" : "closed"}
                                            initial={{ y: -15, }}
                                            variants={{
                                                open: { y: 0, },
                                                closed: { y: -100, },
                                            }}
                                            exit={{ opacity: 0, y: -15 }}
                                            transition={{ duration: 0.2 }}
                                            className="rounded-xl overflow-hidden bg-white dark:bg-[#292757] shadow-lg top-12 left-0 lg:absolute
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] z-50
                                                        min-w-[140px] max-w-[160px]">
                                            {['Categories', 'Categories 1', 'Categories 3', 'Categories 4', 'Categories 5',].map(item =>
                                                <div onClick={() => { setCategoriesText(item) }}
                                                    className={`py-3 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                    <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium 
                                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                                </div>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>



                        <div className={onSaleFilterOptionStye}
                            onClick={() => setCollectionsDropOpen(!collectionsDropOpen)}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 md:w-5" viewBox="0 0 18.254 19.658">
                                <g id="Group_1369" data-name="Group 1369" transform="translate(-637.039 -507)">
                                    <path id="Path_904" data-name="Path 904" d="M14.32,33.97H8.886A2.886,2.886,0,0,0,6,36.856v6.449a2.886,2.886,0,0,0,2.886,2.886H14.32a2.886,2.886,0,0,0,2.886-2.886V36.856A2.886,2.886,0,0,0,14.32,33.97Z" transform="translate(632.257 479.03)" fill="#6561b1" />
                                    <path id="Path_905" data-name="Path 905" d="M9.538,42.627H4.1a4.108,4.108,0,0,1-4.1-4.1V32.076A4.11,4.11,0,0,1,4.1,27.97H9.538a4.11,4.11,0,0,1,4.1,4.106v6.447a4.108,4.108,0,0,1-4.1,4.1ZM4.1,30.406a1.671,1.671,0,0,0-1.669,1.671v6.447A1.671,1.671,0,0,0,4.1,40.192H9.538a1.671,1.671,0,0,0,1.669-1.669V32.076a1.671,1.671,0,0,0-1.669-1.671Z" transform="translate(637.039 484.03)" fill="#6561b1" />
                                    <path id="Path_906" data-name="Path 906" d="M32.267,14.657H26.835a4.108,4.108,0,0,1-4.1-4.106V4.1a4.108,4.108,0,0,1,4.1-4.1h5.432a4.108,4.108,0,0,1,4.1,4.1v6.447a4.108,4.108,0,0,1-4.1,4.106ZM26.835,2.436A1.671,1.671,0,0,0,25.166,4.1v6.447a1.671,1.671,0,0,0,1.669,1.671h5.432a1.673,1.673,0,0,0,1.671-1.671V4.1a1.671,1.671,0,0,0-1.671-1.669Z" transform="translate(618.922 507)" fill="#6561b1" opacity="0.81" />
                                </g>
                            </svg>

                            <div ref={collectionsDropRef} className="text-left ml-2">
                                <div className="flex justify-between items-center break-all">
                                    <h4 className="text-[#6F6DAB] font-semibold text-xs sm:text-sm xl:text-base mr-1 max-w-[140px]
                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{collectionsText}</h4>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className={`h-4 w-4 transition-all ${collectionsDropOpen && 'rotate-180'}`}
                                        fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>

                                <AnimatePresence>
                                    {collectionsDropOpen &&
                                        <motion.div
                                            animate={collectionsDropOpen ? "open" : "closed"}
                                            initial={{ y: -15, }}
                                            variants={{
                                                open: { y: 0, },
                                                closed: { y: -100, },
                                            }}
                                            exit={{ opacity: 0, y: -15 }}
                                            transition={{ duration: 0.2 }}
                                            className="rounded-xl overflow-hidden bg-white dark:bg-[#292757] shadow-lg top-12 left-0 lg:absolute
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] z-50
                                                        min-w-[140px] max-w-[160px]">
                                            {['Collections', 'Collections 1', 'Collections 3', 'Collections 4', 'Collections 5',].map(item =>
                                                <div onClick={() => { setCollectionsText(item) }}
                                                    className={`py-3 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                    <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium 
                                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                                </div>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>
                    </div>



                    <div className="flex gap-y-3 justify-start items-start gap-x-4 ">
                        <div className={onSaleFilterOptionStye}
                            onClick={() => setSaleTypeDropOpen(!saleTypeDropOpen)}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-3 md:w-4" viewBox="0 0 13.557 20.335">
                                <path id="flash" d="M1.059,11.862H4.8l-.773,7.3c0,.022,0,.087,0,.109a1.061,1.061,0,0,0,1.059,1.059,1.072,1.072,0,0,0,.859-.441l7.4-10.573A1.059,1.059,0,0,0,12.5,7.625H7.917L8.68,1.183c0-.025,0-.1,0-.124A1.059,1.059,0,0,0,7.626,0,1.078,1.078,0,0,0,6.76.45L.212,10.167a1.059,1.059,0,0,0,.847,1.695Zm0,0" transform="translate(0 0)" fill="#6560b0" />
                            </svg>



                            <div ref={saleTypeDropRef} className="text-left ml-2">
                                <div className="flex justify-between items-center break-all">
                                    <h4 className="text-[#6F6DAB] font-semibold text-xs sm:text-sm xl:text-base mr-1 max-w-[140px]
                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{saleTypeText}</h4>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className={`h-4 w-4 transition-all ${saleTypeDropOpen && 'rotate-180'}`}
                                        fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>

                                <AnimatePresence>
                                    {saleTypeDropOpen &&
                                        <motion.div
                                            animate={saleTypeDropOpen ? "open" : "closed"}
                                            initial={{ y: -15, }}
                                            variants={{
                                                open: { y: 0, },
                                                closed: { y: -100, },
                                            }}
                                            exit={{ opacity: 0, y: -15 }}
                                            transition={{ duration: 0.2 }}
                                            className="rounded-xl overflow-hidden bg-white dark:bg-[#292757] shadow-lg top-12 left-0 lg:absolute
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] z-50
                                                        min-w-[140px] max-w-[160px]">
                                            {['Sale Type', 'Sale Type 1', 'Sale Type 3', 'Sale Type 4', 'Sale Type 5',].map(item =>
                                                <div onClick={() => { setSaleTypeText(item) }}
                                                    className={`py-3 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                    <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium 
                                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                                </div>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>




                        <div className={onSaleFilterOptionStye}
                            onClick={() => setPriceRangeDropOpen(!priceRangeDropOpen)}>
                            <svg id="dollar" xmlns="http://www.w3.org/2000/svg" className="w-4 md:w-5" viewBox="0 0 17.669 17.669">
                                <path id="Path_909" data-name="Path 909" d="M15.082,2.588A8.835,8.835,0,0,0,2.588,15.082,8.835,8.835,0,0,0,15.082,2.588ZM8.835,8.283a2.484,2.484,0,0,1,.679,4.874.173.173,0,0,0-.127.166v.465a.562.562,0,0,1-.525.567.552.552,0,0,1-.579-.552v-.481a.173.173,0,0,0-.127-.166A2.489,2.489,0,0,1,6.35,10.783a.561.561,0,0,1,.536-.567.552.552,0,0,1,.568.552,1.38,1.38,0,1,0,1.38-1.38,2.484,2.484,0,0,1-.679-4.874.173.173,0,0,0,.127-.166V3.881a.562.562,0,0,1,.525-.567.552.552,0,0,1,.579.552v.481a.173.173,0,0,0,.127.166,2.489,2.489,0,0,1,1.806,2.374.561.561,0,0,1-.536.567.552.552,0,0,1-.568-.552,1.38,1.38,0,1,0-1.38,1.38Z" transform="translate(0)" fill="#6560b0" />
                            </svg>

                            <div ref={priceRangeDropRef} className="text-left ml-2">
                                <div className="flex justify-between items-center break-all">
                                    <h4 className="text-[#6F6DAB] font-semibold text-xs sm:text-sm xl:text-base mr-1 max-w-[140px]
                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{priceRangeText}</h4>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className={`h-4 w-4 transition-all ${priceRangeDropOpen && 'rotate-180'}`}
                                        fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>

                                <AnimatePresence>
                                    {priceRangeDropOpen &&
                                        <motion.div
                                            animate={priceRangeDropOpen ? "open" : "closed"}
                                            initial={{ y: -15, }}
                                            variants={{
                                                open: { y: 0, },
                                                closed: { y: -100, },
                                            }}
                                            exit={{ opacity: 0, y: -15 }}
                                            transition={{ duration: 0.2 }}
                                            className="rounded-xl overflow-hidden bg-white dark:bg-[#292757] shadow-lg top-12 left-0 lg:absolute
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] z-50
                                                        min-w-[140px] max-w-[160px]">
                                            {['Price Range', 'Price Range 1', 'Price Range 3', 'Price Range 4', 'Price Range 5',].map(item =>
                                                <div onClick={() => { setPriceRangeText(item) }}
                                                    className={`py-3 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                    <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium 
                                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                                </div>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>






                        <div className={onSaleFilterOptionStye}
                            onClick={() => setSortByDropOpen(!sortByDropOpen)}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-2.5 md:w-3.5" viewBox="0 0 15 21">
                                <g id="sort" transform="translate(-6 -2)">
                                    <path id="Path_910" data-name="Path 910" d="M6.75,10.25h13.5a.75.75,0,0,0,.53-1.28L14.03,2.22a.75.75,0,0,0-1.061,0L6.22,8.97a.75.75,0,0,0,.53,1.28Z" fill="#6560b0" />
                                    <path id="Path_911" data-name="Path 911" d="M20.25,19H6.75a.75.75,0,0,0-.53,1.28l6.75,6.75a.75.75,0,0,0,1.061,0l6.75-6.75A.75.75,0,0,0,20.25,19Z" transform="translate(0 -4.25)" fill="#6560b0" />
                                </g>
                            </svg>

                            <div ref={sortByDropRef} className="text-left ml-2">
                                <div className="flex justify-between items-center break-all">
                                    <h4 className="text-[#6F6DAB] font-semibold text-xs sm:text-sm xl:text-base mr-1 max-w-[140px]
                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{sortByText}</h4>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className={`h-4 w-4 transition-all ${sortByDropOpen && 'rotate-180'}`}
                                        fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>

                                <AnimatePresence>
                                    {sortByDropOpen &&
                                        <motion.div
                                            animate={sortByDropOpen ? "open" : "closed"}
                                            initial={{ y: -15, }}
                                            variants={{
                                                open: { y: 0, },
                                                closed: { y: -100, },
                                            }}
                                            exit={{ opacity: 0, y: -15 }}
                                            transition={{ duration: 0.2 }}
                                            className="rounded-xl overflow-hidden bg-white dark:bg-[#292757] shadow-lg top-12 left-0 lg:absolute
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] z-50
                                                        min-w-[140px] max-w-[160px]">
                                            {['Sort by', 'Sort by 1', 'Sort by 3', 'Sort by 4', 'Sort by 5',].map(item =>
                                                <div onClick={() => { setSortByText(item) }}
                                                    className={`py-3 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                    <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium 
                                                    whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                                </div>
                                            )}
                                        </motion.div>}
                                </AnimatePresence>
                            </div>
                        </div>


                    </div>
                </div>
            </div>








            <div className="mt-7 xs:px-2 sm:px-0 mb-24 grid xs:grid-cols-1 xsm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-6 gap-x-4 gap-y-4">

                {exploreEtherDatas.map((data, index) =>
                    <div className="p-3 rounded-lg mt-5 h-full overflow-visible transition-all
                            bg-[#ffffff] dark:bg-[#292757] dark:hover:bg-[#CA12F6] hover:bg-[#CA12F6] border border-[#D8D8D8] dark:border-[#292757] group
                            " key={data.id}>
                        <div className="flex justify-between items-center">
                            <div className="flex justify-start items-center ml-3">
                                {data.profiles.map((prfl, index) =>
                                    <img key={index} src={prfl} alt="" className="w-6 h-6 -ml-2" />
                                )}
                            </div>
                            <div className="flex justify-end items-center">

                                <div
                                    className="flex cursor-pointer justify-between py-1 px-2 items-center rounded-full
                                            bg-[#F5F5F5] dark:bg-[#140D36] group-hover:bg-[#e589fb]"
                                    onClick={() => handleLoveOnClick(index)}>
                                    <p className="text-gray-800 dark:text-cusBlueWhite text-xs mr-0.5 
                                            dark:group-hover:text-white group-hover:text-white">{data.nftPostData.loves}</p>

                                    {data.nftPostData.isMyloves &&
                                        <motion.svg
                                            initial={{ scale: 0.5 }}
                                            animate={{ scale: 1 }}
                                            xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 group-hover:stroke-[#CA12F6]" fill="#CA12F6" viewBox="0 0 24 24" stroke="#CA12F6" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                        </motion.svg>
                                    }

                                    {!data.nftPostData.isMyloves &&
                                        <motion.svg
                                            initial={{ scale: 0.5 }}
                                            animate={{ scale: 1 }}
                                            xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 group-hover:stroke-[#CA12F6]" fill="none" viewBox="0 0 24 24" stroke="#6f6dab" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                        </motion.svg>
                                    }
                                </div>


                                <div className="relative" ref={(el) => threeDotModalRefs.current[index] = el}>
                                    <button className="ml-3 three_dot_btn" onClick={() => hanldeThreeDotBtn(index)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={5} height={18} viewBox="0 0 5 21">
                                            <g id="Group_1481" data-name="Group 1481" transform="translate(0)">
                                                <circle className="group-hover:fill-white" id="Ellipse_374" data-name="Ellipse 374" cx="2.5" cy="2.5" r="2.5" transform="translate(0)" fill="#6f6dab" />
                                                <circle className="group-hover:fill-white" id="Ellipse_375" data-name="Ellipse 375" cx="2.5" cy="2.5" r="2.5" transform="translate(0 8)" fill="#6f6dab" />
                                                <circle className="group-hover:fill-white" id="Ellipse_376" data-name="Ellipse 376" cx="2.5" cy="2.5" r="2.5" transform="translate(0 16)" fill="#6f6dab" />
                                            </g>
                                        </svg>
                                    </button>
                                    <div className="absolute right-0 top-6 z-50">
                                        <AnimatePresence>
                                            {isThreeDotModalOpen[index] &&
                                                <motion.div
                                                    initial={{ height: 0, width: 0 }}
                                                    animate={{ height: "auto", width: '' }}
                                                    exit={{ height: 0, width: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    className="overflow-hidden w-full max-w-[192px] bg-white border-2 dark:border-[#ffffff10] shadow-2xl shadow-[#00000050] dark:bg-[#363375] rounded"
                                                >
                                                    {["Place floor bid", "New Bid", "Refresh Metadata", "Share", "Open original on IPFS", "Report"].map(item =>
                                                        <div
                                                            className="w-full py-1.5 cursor-pointer hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 text-left"
                                                            key={item}
                                                            onClick={() => hanldeThreeDotBtn(index)}>
                                                            <h5 className="text-l-LightBlack dark:text-white text-base whitespace-nowrap font-semibold
                                                                    overflow-hidden overflow-ellipsis">{item}</h5>
                                                        </div>
                                                    )}
                                                </motion.div>
                                            }
                                        </AnimatePresence>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="xs:h-56 sm:h-44 relative mt-2 rounded-xl">
                            <div className="w-full h-full rounded-lg overflow-hidden">
                                <img src={data.thumb} alt="" className="w-full h-full hover:scale-125 transition-all" />
                            </div>

                            <div className="w-9/12 rounded-tr-xl bg-cusBlack absolute left-0 bottom-0 p-1 flex justify-start items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={16} height={15} viewBox="0 0 16 15">
                                    <defs>
                                        <clipPath id="clip-path">
                                            <rect id="Rectangle_814" data-name="Rectangle 814" width={16} height={15} transform="translate(0 0)" fill="#fb0" />
                                        </clipPath>
                                    </defs>
                                    <g id="Group_1121" data-name="Group 1121" transform="translate(0 0)" clipPath="url(#clip-path)">
                                        <path id="Path_662" data-name="Path 662" d="M113.614,342c-3.234,1.864-2.846,7.114-2.846,7.114a2.527,2.527,0,0,1-1.423-2.608,5.782,5.782,0,0,0-2.846,4.979,5.691,5.691,0,0,0,11.382,0c0-4.624-4.268-5.573-4.268-9.485Zm-.923,13.216a2.134,2.134,0,1,1-1.033-4.142c2.761-.688,3.107-2.242,3.107-2.242s1.377,5.523-2.075,6.383Z" transform="translate(-104.749 -341.967)" fill="#fb0" />
                                    </g>
                                </svg>
                                <UseTimeCountdown endDate={data.time} />
                            </div>
                        </div>

                        <div className="mt-4 mb-2 flex justify-between items-center">
                            <h4 className="text-sm text-cusBlack dark:text-white group-hover:text-white ">"{data.title}</h4>
                            <svg className="w-[11px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                            </svg>
                        </div>


                        <p className="text-cusBlack dark:text-cusBlueWhite group-hover:text-[#A4B1E2] text-xs text-left">{data.author}</p>

                        <div className="flex justify-between items-center">
                            <h4 className="text-xs font-semibold text-cusBlack dark:text-white group-hover:text-white">{data.price} ETH</h4>
                            <p className="text-xs text-cusBlack dark:text-cusBlueWhite group-hover:text-[#A4B1E2] ">1/{data.aMA}</p>

                            <button onClick={() => handleNFTOnClick(data.id)} className="font-semibold
                                    bg-cusBrightLink dark:bg-black text-sky-800 dark:text-cusLink text-xs px-2.5 py-1 rounded-full">
                                {data.authorShow ? "Place a Bid" : "Buy Now"}
                            </button>
                        </div>
                    </div>
                )}





            </div>

            <div className="Load_more_btn_box inline-block mb-24">
                <button className="bg-white dark:bg-cusBlack px-8 py-3 rounded-xl font-bold text-cusBlack dark:text-white">
                    Load More
                </button>
            </div>



        </div>
    );
}
